import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'includes',
    standalone: false
})
export class IncludesPipe implements PipeTransform {
    public transform<T>(array: T[], value: T): boolean {
        if (!array) return false;

        return array.includes(value);
    }
}
